/**
 * The delegation link token, held for the lifetime of the public page.
 *
 * Shared form components (file upload, database-backed dropdowns) call the
 * normal authenticated services. On the public page there is no session, so
 * those services consult this module and route to the token-scoped endpoints
 * instead. Keeping the decision in the service layer means the components
 * themselves stay unaware of how they were opened.
 */
let activeToken: string | null = null;

export const delegationSession = {
  set(token: string | null) {
    activeToken = token;
  },
  get(): string | null {
    return activeToken;
  },
  get isActive(): boolean {
    return activeToken !== null;
  },
  headers(): Record<string, string> {
    return activeToken ? { "x-delegation-token": activeToken } : {};
  },
};
